import { render, staticRenderFns } from "./ModalRegraGestaoIncluir.vue?vue&type=template&id=4d703d9c&scoped=true"
import script from "./ModalRegraGestaoIncluir.vue?vue&type=script&lang=ts"
export * from "./ModalRegraGestaoIncluir.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraGestaoIncluir.vue?vue&type=style&index=0&id=4d703d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d703d9c",
  null
  
)

export default component.exports